export default {
    'name': 'minus',
    'width': '24',
    'height': '24',
    'viewBox': '0 0 24 24',
    'data': '<path fill-rule=\'evenodd\' clip-rule=\'evenodd\' d=\'M21.75 11.5627C21.6139 11.3733 21.3916 11.25 21.1406 11.25H2.85938C2.60835 11.25 2.38614 11.3733 2.25 11.5627V12.4373C2.38614 12.6267 2.60835 12.75 2.85938 12.75H21.1406C21.3916 12.75 21.6139 12.6267 21.75 12.4373V11.5627Z\' fill=\'#026958\'/>'
}
